import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import PaymentResult from "./pages/PaymentResult";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, anchors: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Toaster position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
